import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#398FF5",
      d: "M15.548 13.441A3.552 3.552 0 0 1 12 16.99a3.551 3.551 0 0 1-3.547-3.548A3.551 3.551 0 0 1 12 9.893a3.552 3.552 0 0 1 3.548 3.548ZM23 8.403V18.48a2.433 2.433 0 0 1-2.433 2.433H3.433A2.433 2.433 0 0 1 1 18.48V8.403A2.433 2.433 0 0 1 3.433 5.97h2.992V5.13C6.425 3.953 7.377 3 8.553 3h6.893c1.177 0 2.13.953 2.13 2.129v.84h2.991A2.434 2.434 0 0 1 23 8.404Zm-5.627 5.038A5.379 5.379 0 0 0 12 8.068a5.379 5.379 0 0 0-5.372 5.373A5.379 5.379 0 0 0 12 18.814a5.379 5.379 0 0 0 5.373-5.373Z"
    }, null, -1)
  ]))]))
}
export default { render: render }